import { render, staticRenderFns } from "./SynchrotronProposalFormMenuActions.vue?vue&type=template&id=f232c24e&scoped=true&"
import script from "./SynchrotronProposalFormMenuActions.vue?vue&type=script&lang=js&"
export * from "./SynchrotronProposalFormMenuActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f232c24e",
  null
  
)

export default component.exports